import React from 'react';
import CodeDiffLine from '~/components/CodeDiffLine';
import CodeDiffHeader from '~/components/CodeDiffHeader';
import CopyToClipboard from '~/containers/CopyToClipboard';

interface PackageManagerBowerProps {
  component: object;
  range?: object;
  safeVersion?: string;
  transitive: boolean;
  unsafeVersion?: string;
  packageFile?: string;
  lineNumber?: string;
}

const PackageManagerBower: React.FunctionComponent<PackageManagerBowerProps> = props => {
  const { component, range = {}, safeVersion, transitive = false, packageFile, lineNumber } = props;
  const { name } = component;
  const unsafeVersion =
    props.unsafeVersion ||
    (range.versionRange && range.versionRange.indexOf('-') !== -1
      ? range.versionRange.split('-')[0]
      : '');

  let diff = null;
  if (!transitive) {
    // Direct
    diff = (
      <div className="grid bo--1 border-color--white-dark mt bg-color--white lh+">
        <CodeDiffHeader text={packageFile} />
        <CodeDiffLine type="normal" text='"dependencies": {' />
        <CodeDiffLine type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine
          type="delete"
          lineNumber={lineNumber}
          text={'\u2003\u0022' + name + '\u0022: \u0022' + unsafeVersion + '\u0022,'}
        />
        <CodeDiffLine
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <CodeDiffLine type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine type="normal" text="}" />
      </div>
    );
  } else {
    diff = (
      <div className="grid bo--1 border-color--white-dark mt bg-color--white lh+">
        <CodeDiffHeader text="bower.json" />
        <CodeDiffLine type="add" text='"dependencies": {' />
        <CodeDiffLine type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <CodeDiffLine type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine type="add" text="}," />
        <CodeDiffLine type="add" text='"resolutions": {' />
        <CodeDiffLine type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <CodeDiffLine type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <CodeDiffLine type="add" text="}" />
      </div>
    );
  }

  return (
    <div className="pt-">
      <div className="grid pt">
        <span className="bg-color--white-dark pv- ph- text--bold">1</span>
        {!transitive && (
          <span className="ph-- pv-">
            {' '}
            Update your <span className="text--bold">{packageFile} </span>
          </span>
        )}
        {transitive && (
          <span className="ph-- pv-">
            {' '}
            Include {name} to your <span className="text--bold">bower.json</span>
          </span>
        )}
        <span className="pv-">as shown below:</span>
      </div>
      {diff}
      <div className="grid pt">
        <span className="bg-color--white-dark pv- ph- text--bold">2</span>
        <span className="pv- pl--">
          After updating {packageFile}, type the following to install{' '}
          <span className="font-family--code bg-color--white-medium p---">
            {name} {safeVersion}
          </span>
        </span>
      </div>
      <div className="pt-- -ml mt-">
        <CopyToClipboard value={`bower update ${name}`} id="PackageManagerBower" />
      </div>
    </div>
  );
};

export default PackageManagerBower;
